module.exports = __webpack_public_path__ + "img/img_ch2_open.58416b56.jpg";